export default function NotAccessMessage() {
  return (
    <div className="job-details-message" style={{ maxWidth: '525px', textAlign:'left', margin: 'auto', marginTop: '10em' }} >
      <h4 style={{ margin: '0 0 1em 0' }} >
        Currently your account does not have access to this page.
      </h4>
      <p>
        Please open a support ticket through MODMAIL in Discord or email beekeeper@encorehive.com to discuss the status of your account.
      </p>
    </div>
  );
}